import { render, staticRenderFns } from "./ComgyApi.vue?vue&type=template&id=54b1d445&lang=pug&"
import script from "./ComgyApi.vue?vue&type=script&lang=ts&"
export * from "./ComgyApi.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports